var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdnsServer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.748,
    height: 40.336,
    viewBox: "0 0 39.748 40.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DDNS_Server",
    "data-name": "DDNS Server",
    transform: "translate(-1775 -22593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2135",
    "data-name": "Rectangle 2135",
    transform: "translate(1775 22593)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 38,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_542",
    "data-name": "Line 542",
    x1: 27,
    transform: "translate(1775.5 22618.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1794 22624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M1958.09,22597.07h7.227a1.732,1.732,0,0,1,1.042.258,1.5,1.5,0,0,1,.377.951v32.484a1.715,1.715,0,0,1-.331,1.189,2.134,2.134,0,0,1-1.271.383h-7.045",
    transform: "translate(-153)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdnsServer);
export default __webpack_public_path__ + "static/media/ddns_server.2ce6fd97359e4f8892ffc60a37fc2d77.svg";
export { ForwardRef as ReactComponent };